import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { companyService } from '@/services/api'

// Estado global de la empresa
const companies = ref([])
const selectedCompanyId = ref(null)
const loadingCompanies = ref(false)
const initialized = ref(false)

export function useCompany() {
  /* SAFE ROUTE ACCESS */
  let route = null
  try {
     route = useRoute()
  } catch (e) {
     // Running outside component context
  }

  const currentCompanyId = computed(() => {
    return selectedCompanyId.value || route?.params?.companyId || localStorage.getItem('current_company_id')
  })

  const currentCompany = computed(() => {
    const targetId = selectedCompanyId.value || route?.params?.companyId || localStorage.getItem('current_company_id')
    if (!targetId) return null
    return companies.value.find(c => c.id == targetId) || null
  })

  const loadCompanies = async () => {
    if (companies.value.length > 0) {
      initialized.value = true
      return
    }
    
    loadingCompanies.value = true
    try {
      const response = await companyService.getCompanies()
      companies.value = response.data || []
      
      // Si hay empresa en la ruta (y tenemos acceso a route), seleccionarla
      // Si estamos en, por ejemplo, router guard, route puede ser null.
      // Se recomienda pasar el ID explícitamente si se conoce.
      
      const routeCompanyId = route?.params?.companyId
      
      if (routeCompanyId) {
        selectedCompanyId.value = Number(routeCompanyId)
      } else {
        const storedCompanyId = localStorage.getItem('current_company_id')
        if (storedCompanyId && companies.value.some(c => c.id == storedCompanyId)) {
          selectedCompanyId.value = Number(storedCompanyId)
        } else if (companies.value.length > 0) {
          // Seleccionar el primero por defecto
          selectedCompanyId.value = companies.value[0].id
          localStorage.setItem('current_company_id', String(companies.value[0].id))
        }
      }
    } catch (error) {
      console.error('Error loading companies:', error)
      throw error
    } finally {
      loadingCompanies.value = false
      initialized.value = true
    }
  }

  const setCompany = (companyId) => {
    selectedCompanyId.value = Number(companyId)
    localStorage.setItem('current_company_id', String(companyId))
  }

  const refreshCompanies = async () => {
    companies.value = []
    initialized.value = false
    await loadCompanies()
  }

  if (!initialized.value && !loadingCompanies.value && companies.value.length === 0) {
    loadCompanies().catch(() => {})
  }

  return {
    companies,
    selectedCompanyId,
    currentCompanyId,
    currentCompany,
    loadingCompanies,
    initialized,
    loadCompanies,
    setCompany,
    refreshCompanies
  }
}
